module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/thurston_promo.0ce2e65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/thurston_promo.jpg
// module id = ZgNE
// module chunks = 1